import { Injectable } from "@angular/core";
import { AxiosResponse } from "axios";
import { AxiosServiceActionNameToActionVerbMap, AxiosServiceRequestOptions, AxiosServiceReturn } from "./axios.service";
import { NbToastrConfig } from "@nebular/theme";

export interface ErrorResponse {
  status: number,
  title: string,
  type?: string,
  detail?: string,
  errors?: {[key: string]: string[] },
  traceId?: string,
}


export interface AxiosServiceResponseProcessorOutput {
  return: AxiosServiceReturn,
  notifications: AxiosServiceNotification[],
}
export interface AxiosServiceNotification {
  status: string,
  title?: string,
  content?: string,
  otherOptions?: Partial<NbToastrConfig>, //coupling for now, could do a temporary 'any' for crude uncoupling but nah
  milliseconds?: number,
}

@Injectable({
    providedIn: 'root'
  })
  export class AxiosServiceResponseProcessor {


    constructor(
    ) {
      // super();
      console.log("in AxiosServiceResponseProcessor constructor");
    }


    process(
      response: AxiosResponse | undefined,
      options: AxiosServiceRequestOptions,
      extras?: { method?: string, url?: string, data?: any}
    ) : AxiosServiceResponseProcessorOutput {

      let ret: AxiosServiceReturn = {};
      let notifications: AxiosServiceNotification[] = [];

      if(response === undefined) {
        let failureMessage = "Failed to get a response or initiate a request. Check your internet connection.";
        if(options?.returnConfig?.returnSuccessStatus) ret.successful = false;
        if(options?.returnConfig?.dataConfig?.returnOnError) ret.data = options.returnConfig.dataConfig.returnOnError;
        if(options?.returnConfig?.messagesConfig?.returnFailureMessage) ret.messages = { failureMessage };
        if(options?.notificationConfig?.errorHandlingConfig?.showGlobalFailureMessageNotification) notifications.push({
          status: 'danger',
          title: failureMessage,

        });
      } else if (response.status < 400){
        const data = response.data;

        let successMessage = options?.statusMessageConfig?.successMessage ?? (
          (options?.statusMessageConfig?.isResourceCRUD && options?.statusMessageConfig?.actionName) ?
            `${options?.statusMessageConfig?.resourceName} ${AxiosServiceActionNameToActionVerbMap[options?.statusMessageConfig?.actionName]} successfully.` :
            "Request processed successfully."
        );

        if(options?.returnConfig?.returnSuccessStatus) ret.successful = true;
        if(options?.returnConfig?.dataConfig?.returnData) ret.data = data;
        if(options?.returnConfig?.messagesConfig?.returnSuccessMessage) ret.messages = { successMessage };

        if(options?.notificationConfig?.successHandlingConfig?.showGlobalSuccessMessageNotification) notifications.push({
          status: 'success',
          title: successMessage,
        });

      } else {
        const errorData: ErrorResponse = response.data;

        let failureMessage = errorData.title;
        let validationErrors = errorData?.errors;

        if(options?.returnConfig?.returnSuccessStatus) ret.successful = false;
        if(options?.returnConfig?.dataConfig?.returnOnError) ret.data = options.returnConfig.dataConfig.returnOnError;
        else if(options?.returnConfig?.dataConfig?.returnErrorData) ret.data = errorData;

        if(options?.returnConfig?.messagesConfig?.returnFailureMessage) ret.messages = { failureMessage };
        if(options?.returnConfig?.messagesConfig?.returnValidationErrors && validationErrors) ret.messages.validationErrors = validationErrors;

        //validation errors notification handling will be updated (maybe taken out...)
        //also resource and action based errors... after adding the options (useActionResourceForErrors?) (Failed to [action] [resource])...
        if(options?.notificationConfig?.errorHandlingConfig?.showGlobalFailureMessageNotification) notifications.push({
          status: 'danger',
          title: failureMessage,
        });
        if(options?.notificationConfig?.errorHandlingConfig?.showGlobalValidationErrorsNotification) notifications.push({
          status: 'danger',
          title: "Validation Errors:  🔴 " + (
            Object.values(validationErrors)
            .map((relatedValidationErrorsList: string[], relatedValidationErrorListIndex) => relatedValidationErrorsList
              .map((validationError: string, validationErrorIndex) => `(${relatedValidationErrorListIndex + 1}.${validationErrorIndex + 1}) ${validationError}`)
              .join("")
            ) //maps to concatenatedRelatedValidationErrorsList
            // .map((concatenatedRelatedValidationErrorsList: string, index) => `(${index + 1}) ${concatenatedRelatedValidationErrorsList}`)
            .join(" 🔴 ")
            ),
          milliseconds: 10000,
        });
      }

      return {
        return: ret,
        notifications: notifications,
      } as AxiosServiceResponseProcessorOutput;

      // return {
      //   return: null,
      //   notifications: [ {status: "danger", title: "Error."}],
      // };
    }


}


// class AppReponse {

// }


